import React from 'react';
import { Modal, Tabs } from 'antd';
import AddRMForm from './components/AddRMForm';
import EditRMForm from './components/EditRMForm';


const RMEditModal = ({ region, open, onClose, onChange }) => {
    const items = [
        {    
            key: "1",
            label: "Add RM",
            children: <AddRMForm region={region} onChange={onChange} />
        },
        {
            key: "2",
            label: "Edit RM",
            children: <EditRMForm region={region} onChange={onChange} />
        }
    ]

    return (
        <Modal
            title="Edit Regional Manager"
            open={open}
            onCancel={onClose}
            footer={[]}
        >
            <Tabs defaultActiveKey="1" items={items} />
        </Modal>
    );
};

export default RMEditModal;